import React, { Component } from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import PrivateRoute from "./routes/PrivateRoute"
import PublicRoute from "./routes/PublicRoute"
import './scss/style.scss';
// import 'toastr/toastr.css';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages 
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page403 = React.lazy(() => import('./views/pages/page403/Page403'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));
const Logout = React.lazy(() => import('./views/pages/logout/Logout'));

class App extends Component {

  render() {
    return (
      <BrowserRouter>
          <React.Suspense fallback={loading}>
            <Switch>
              <PublicRoute exact restricted={true} path="/login" name="Login Page" component={props => <Login {...props}/>} />
              <PublicRoute exact restricted={false} path="/register" name="Register Page" component={props => <Register {...props}/>} />
              <PublicRoute exact path="/404" name="Page 404" component={props => <Page404 {...props}/>} />
              <PublicRoute exact path="/403" name="Page 403" component={props => <Page403 {...props}/>} />
              <PublicRoute exact path="/500" name="Page 500" component={props => <Page500 {...props}/>} />
              <PrivateRoute path="/logout" name="Logout" component={props => <Logout {...props}/>} />
              <PrivateRoute path="/" name="Home" component={props => <TheLayout {...props}/>} />
            </Switch>
          </React.Suspense>
      </BrowserRouter>
    );
  }
}

export default App;
